import React from "react";
import PropTypes from "prop-types";
import BrandRankingItem from "./BrandRankingItem";
import BrandRankingMore from "./BrandRankingMore";
import "./BrandRankingHorizontalList.css";

const PAGE_SIZE = 10;

/**
 * 브랜드 랭킹 2-column layout
 * PC 에서는 가로형
 * 모바일에서는 세로형
 * @param title
 * @param brands
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export default function BrandRankingHorizontalList({ title, brands }) {
  if (!brands || brands.length === 0) return null;

  const start = 0;
  const currentBrands = brands.slice(start, start + PAGE_SIZE);

  const leftCol = currentBrands.slice(0, 5);
  const rightCol = currentBrands.slice(5, 10);

  return (
    <section className="BrandRankingHorizontalList">
      <h2 className="BrandRankingHorizontalList-title">{title}</h2>
      <div className="BrandRankingHorizontalList-wrapper">
        <div className="BrandRankingHorizontalList-columns">
          <ul className="BrandRankingHorizontalList-items" role="list">
            {leftCol.map((brand, idx) => (
              <BrandRankingItem
                key={brand.id}
                rank={start + idx + 1}
                brand={brand}
              />
            ))}
          </ul>
          <ul className="BrandRankingHorizontalList-items" role="list">
            {rightCol.map((brand, idx) => (
              <BrandRankingItem
                key={brand.id}
                rank={start + idx + 6}
                brand={brand}
              />
            ))}
          </ul>
        </div>
      </div>
      <BrandRankingMore />
    </section>
  );
}

BrandRankingHorizontalList.propTypes = {
  title: PropTypes.string.isRequired,
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string.isRequired,
      name_kr: PropTypes.string,
      resizedSmallLogo: PropTypes.string,
    }),
  ).isRequired,
};
